import styled, { css } from 'styled-components';
import Button from '@mui/material/Button';
import { Colors } from './CustomButton';
import { Palette } from 'config';

export const Container = styled.div`
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  & .MuiButton-contained.Mui-focusVisible {
    box-shadow: 0px 0px 0px 3px rgba(59, 137, 246, 0.16);
  }
`;

export const StyledButton = styled(Button)``;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${({ isIcon }) => (isIcon ? '10px' : 0)};
  height: 20px;
  width: 20px;
  svg {
    height: inherit;
    width: inherit;
  }
`;

export const StyledButonWrapper = styled.div`
  border: 1px solid transparent;
  display: flex;
  ${StyledButton} {
    height: 40px;
    padding: ${({ isIcon }) => (isIcon ? '10px 24px' : '12px')};
    padding: ${({ square }) => square && '10px 14px'};
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-transform: none;
    border: 1px solid transparent;
    border-radius: 4px;
    /* box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05); */
    white-space: nowrap;
    transition: 0.1s ease-in-out;
    svg {
      transition: 0.1s ease-in-out;
    }

    &:hover {
      border: 1px solid transparent;
    }
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: auto;
    }
    &:focus {
      * {
        background-color: transparent;
      }
    }
    &.MuiButtonBase-root {
      min-width: 20px;
    }
    & .MuiButton-label {
      align-items: center;
    }
    ${({ btnWrapperStyle }) =>
      btnWrapperStyle &&
      css`
        ${btnWrapperStyle}
      `}
  }

  ${({ buttonColor, isMutedTertiary }) => {
    switch (buttonColor) {
      case Colors.Primary: {
        return css`
          color: #ffffff;
          ${IconWrapper} {
            svg {
              fill: #ffffff;
            }
          }

          &:hover {
            ${StyledButton} {
              background-color: ${() => Palette.Primary._600};
              box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
            }
          }
          &:active,
          &:focus {
            ${StyledButton} {
              background-color: ${() => Palette.Primary._500};
              box-shadow: 0px 0px 0px 3px rgba(59, 137, 246, 0.16);
            }
          }
          &:active {
            color: ${Palette.Primary._100};
          }
          ${StyledButton} {
            background-color: ${() => Palette.Primary._500};
            box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
            &:disabled {
              color: #ffffff;
              background-color: ${() => Palette.Primary._500};
              &:hover {
                background-color: ${() => Palette.Primary._500};
              }
            }
          }
        `;
      }
      case Colors.Secondary: {
        return css`
          color: ${() => Palette.Primary._500};
          ${IconWrapper} {
            svg {
              fill: ${() => Palette.Primary._500};
            }
          }

          &:hover {
            ${StyledButton} {
              background-color: #fff;
              box-shadow: 0px 2px 2px 0px rgba(28, 53, 106, 0.05);
              &:not(:disabled) {
                border: 1px solid ${() => Palette.Primary._300};
              }
            }
          }
          &:active,
          &:focus {
            ${StyledButton} {
              background-color: ${() => Palette.Primary._000};
              box-shadow: 0px 0px 0px 3px rgba(59, 137, 246, 0.16);
              border: 1px solid ${() => Palette.Primary._300};
            }
          }
          ${StyledButton} {
            background-color: #ffffff;
            box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.05);
            border: 1px solid ${() => Palette.Gray._200};
            &:disabled {
              color: ${() => Palette.Primary._500};
              background-color: #ffffff;
              border: 1px solid ${() => Palette.Gray._200};
              box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
              &:hover {
                //background-color: ${() => Palette.Primary._500};
                border: 1px solid ${() => Palette.Gray._200};
                box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
              }
            }
          }
        `;
      }
      case Colors.Tertiary: {
        return css`
          color: ${() => Palette.Gray._800};

          ${IconWrapper} {
            svg {
              fill: ${() =>
                isMutedTertiary ? Palette.PrimaryGray._400 : Palette.PrimaryGray._500};
            }
          }
          &:hover,
          &:active,
          &:focus {
            ${IconWrapper} {
              svg {
                fill: ${() => Palette.Primary._500};
              }
            }
          }

          &:hover {
            ${StyledButton} {
              background-color: ${() => Palette.Primary._000};
              box-shadow: none;
            }
          }
          &:active,
          &:focus {
            ${StyledButton} {
              //background-color: ${() => Palette.Primary._000}
              background: inherit;
              box-shadow: 0px 0px 0px 3px rgba(59, 137, 246, 0.16);
              //border: 1px solid ${() => Palette.Primary._300};
            }
          }

          ${StyledButton} {
            background-color: transparent;
            box-shadow: none;

            &:disabled {
              background-color: transparent;
              box-shadow: none;

              svg {
                fill: ${() => Palette.PrimaryGray._400};
              }
              &:hover {
                background-color: transparent;
                box-shadow: none;
              }
            }
          }
        `;
      }
      case Colors.Delete: {
        return css`
          color: #fff;

          ${IconWrapper} {
            svg {
              fill: ${() => Palette.PrimaryGray._000};
            }
          }
          &:hover,
          &:active,
          &:focus {
            ${IconWrapper} {
              svg {
                fill: #fff;
              }
            }
          }

          &:hover {
            ${StyledButton} {
              background-color: ${() => Palette.Red._600};
              box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
            }
          }
          &:active,
          &:focus {
            ${StyledButton} {
              background-color: ${() => Palette.Red._500};
              box-shadow: 0px 0px 0px 3px rgba(59, 137, 246, 0.16), 0px 2px 2px rgba(0, 0, 0, 0.05);
              border: 1px solid transparent;
            }
          }

          ${StyledButton} {
            background-color: ${() => Palette.Red._500};
            box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
            &:disabled {
              color: #fff;
              background-color: ${() => Palette.Red._500};
              box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
              opacity: 0.5;
              &:hover {
                background-color: ${() => Palette.Red._500};
                box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
                opacity: 0.5;
              }
            }
          }
        `;
      }
      default: {
        return;
      }
    }
  }}

  ${({ isPressed }) => {
    if (isPressed) {
      return css`
        background-color: ${() => Palette.Primary._000};
        border-radius: 4px;
        border: 1px solid ${Palette.Primary._300};
        color: ${Palette.Primary._500};
        svg {
          fill: ${Palette.Primary._500}!important;
        }
      `;
    }
  }}
`;
